<template>
  <transition name="c-base-modal">
    <div v-if="show" class="c-base-modal">
      <div class="c-base-modal__bottom">
        <div class="c-base-modal__header">
          <div class="container has-text-centered">
            <strong v-if="title">{{ title }}</strong>
            <button
              v-if="btnClose"
              @click="close"
              type="button"
              class="c-base-modal__button-close"
            >
              <!-- Slot to set icon button close -->
              <slot name="btn-close-icon"></slot>
            </button>
          </div>
        </div>
        <div class="c-base-modal__body">
          <!-- Slot to set content body -->
          <slot></slot>
        </div>
        <div v-if="isFooter" class="c-base-modal__footer">
          <!-- Slot to set content footer -->
          <slot name="footer"></slot>
        </div>
      </div>
      <a
        @click="withClickOverlay ? close : ''"
        class="c-base-modal__overlay"
      ></a>
    </div>
  </transition>
</template>

<script>
const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL

export default {
  props: {
    // Define title of dialog box
    title: {
      type: String,
      required: false,
    },
    // Defines whether footer is visible or not
    isFooter: {
      type: Boolean,
      required: false,
    },
    // Optional function callback that triggers when modal is closed.
    onClose: {
      type: Function,
      required: false,
    },

    wedId: {
      type: String,
    },

    withClickOverlay: {
      type: Boolean,
      default: true,
    },

    btnClose: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      // Defines whether modal is opened or not
      show: false,
      globalTagHTML: null,
      summaryComponent: null,
    }
  },

  methods: {
    // Opens the modal.
    open() {
      this.show = true
      this.fixedglobalTagHTML()
      this.fixedComponentSummary()
    },
    // Closes the modal and triggers funcion callback if there's one
    close() {
      if (!this.wedId && this.$route.query.go !== 'shopping') {
        this.show = false
        this.fixedglobalTagHTML()
        if (this.onClose) this.onClose()
      } else {
        window.location.href = `${API_LEGACY_URL}/${this.wedId}`
      }
    },
    // Fixed global body
    fixedglobalTagHTML() {
      if (this.globalTagHTML === null)
        this.globalTagHTML = document.getElementsByTagName('html')[0]

      if (this.globalTagHTML && this.show) {
        this.globalTagHTML.style.overflow = 'hidden'
      } else if (this.globalTagHTML && !this.show) {
        this.globalTagHTML.style.overflow = 'initial'
      }
    },
    fixedComponentSummary() {
      if (this.summaryComponent === null)
        this.summaryComponent = document.getElementById('values-summary')

      if (this.summaryComponent && this.show) {
        this.summaryComponent.classList.remove('c-wallet-values-summary--fixed')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-modal {
  &__bottom {
    @include position(fixed, auto, 0, 0, 0);
    color: $black;
    z-index: 55;
    background-color: $white;
  }

  &__header {
    @include app-shadow();
    height: 40px;
    line-height: 40px;
    background-color: $gray-2;
  }

  &__button-close {
    @include position(absolute, 0, 12px, 0, auto);
    display: inline-flex;
    width: 40px;
    height: 40px;
    align-items: center;
    text-align: center;
    color: $white;
    border: 0;
    outline: none;
    cursor: pointer;
    background-color: $error;
    &:hover,
    &:focus {
      outline: none;
      background-color: $errordark;
    }
    > img,
    > svg,
    > span,
    > i {
      display: inline-flex;
      margin: 0 auto;
    }
  }

  &__body {
    padding: 32px 16px;
    height: 100%;
    max-height: calc(100vh - 200px);
    overflow: auto;
  }

  &__footer {
    padding: 16px;
  }

  &__overlay {
    display: block;
    @include position(fixed, 0, 0, 0, 0);
    width: 100%;
    height: 100%;
    z-index: 50;
  }

  // animation
  &-enter-active,
  &-leave-active,
  .c-base-modal__overlay,
  .c-base-modal__bottom {
    transition: opacity 400ms ease-in-out, transform 400ms ease-in-out;
  }
  &-enter,
  &-leave-to {
    .c-base-modal__overlay {
      opacity: 0;
    }
    .c-base-modal__bottom {
      transform: translateY(105%);
    }
  }
}
</style>
